import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "hooks/morning/axiosInstanse";

interface FaqDetailRequest {
    category: string;
    list_no: number | null;
}

export interface FaqDetailResponseData {
    b_file: string;
    contents: string;
    flag: boolean;
    list_no: number;
    nextList: { list_no: number; subject: string; M_ID: string };
    prevList: any;
    subject: string;
    w_date: string;
}

export const useGetFaqDetail = ({ category, list_no }: FaqDetailRequest): UseQueryResult<FaqDetailResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetFaqDetail", category, list_no],
        queryFn: async () => {
            let url = enum_api_uri.get_faq_detail.replace(":category", category).replace(":list_no", list_no!.toString());
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: list_no !== null,
    });
};
